import { render, staticRenderFns } from "./EditEventModal.vue?vue&type=template&id=0938123f&scoped=true"
import script from "./EditEventModal.vue?vue&type=script&lang=js"
export * from "./EditEventModal.vue?vue&type=script&lang=js"
import style0 from "./EditEventModal.vue?vue&type=style&index=0&id=0938123f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0938123f",
  null
  
)

export default component.exports